export const CREDIT_VOID = Object.freeze({
    HEADERS: [
        { text: "Invoice Type", value: "invoiceType"},
        { text: "Void", value: "void"},
        { text: "Credit", value: "credit"}
      ]
});